// trafficSource.ts (web) — display metadata for an order's acquisition channel.
// Keys match the canonical set produced by the worker's normaliser
// (worker/src/lib/trafficSource.ts). Emoji icons are acceptable here — the admin
// already uses emoji throughout.

export interface SourceMeta {
  label: string;
  emoji: string;
}

const SOURCE_META: Record<string, SourceMeta> = {
  instagram: { label: 'Instagram', emoji: '📸' },
  facebook:  { label: 'Facebook',  emoji: '📘' },
  tiktok:    { label: 'TikTok',    emoji: '🎵' },
  google:    { label: 'Google',    emoji: '🔍' },
  chatgpt:   { label: 'ChatGPT',   emoji: '🤖' },
  snapchat:  { label: 'Snapchat',  emoji: '👻' },
  youtube:   { label: 'YouTube',   emoji: '▶️' },
  whatsapp:  { label: 'WhatsApp',  emoji: '💬' },
  direct:    { label: 'Direct',    emoji: '🔗' },
  other:     { label: 'Autre',     emoji: '❓' },
};

const FALLBACK: SourceMeta = { label: 'Direct', emoji: '🔗' };

/** Display label + emoji for a traffic source. Null/unknown → Direct. */
export function sourceMeta(source: string | null | undefined): SourceMeta {
  if (!source) return FALLBACK;
  return SOURCE_META[source] ?? SOURCE_META.other;
}
